import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const ExternalLinkIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-external-link', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.323 2.07291H13.9896V6.51291H12.6562V4.34904L8.12762 8.87764C7.86727 9.13799 7.44516 9.13799 7.18481 8.87764C6.92447 8.6173 6.92447 8.19518 7.18481 7.93484L11.7134 3.40624H9.54956V2.07291H13.3228C13.3228 2.07291 13.3229 2.07291 13.323 2.07291ZM3.78 3.33331V3.33332H6.66666C7.03485 3.33332 7.33333 3.63179 7.33333 3.99998C7.33333 4.36817 7.03485 4.66665 6.66666 4.66665H3.78207C3.72159 4.66713 3.66181 4.67971 3.60626 4.70366C3.55031 4.72777 3.49979 4.76292 3.45773 4.807C3.41566 4.85108 3.38292 4.90318 3.36144 4.9602C3.33997 5.01722 3.33021 5.07799 3.33275 5.13886C3.33314 5.14812 3.33333 5.15738 3.33333 5.16665V12.1667C3.33333 12.2993 3.38601 12.4264 3.47978 12.5202C3.57355 12.614 3.70072 12.6667 3.83333 12.6667H10.8333C10.9659 12.6667 11.0931 12.614 11.1869 12.5202C11.2807 12.4264 11.3333 12.2993 11.3333 12.1667V9.33332C11.3333 8.96513 11.6318 8.66665 12 8.66665C12.3682 8.66665 12.6667 8.96513 12.6667 9.33332V12.1667C12.6667 12.6529 12.4735 13.1192 12.1297 13.463C11.7859 13.8068 11.3196 14 10.8333 14H3.83333C3.3471 14 2.88078 13.8068 2.53697 13.463C2.19315 13.1192 2 12.6529 2 12.1667V5.17893C1.99225 4.9442 2.03085 4.71019 2.11366 4.49031C2.19828 4.26558 2.32735 4.06022 2.49313 3.88649C2.65891 3.71277 2.85801 3.57425 3.07853 3.4792C3.29906 3.38416 3.53648 3.33455 3.77661 3.33332L3.78 3.33331Z'
      />
    </svg>
  );
};

export default ExternalLinkIcon;
